import angular from 'angular';

import Component from './form-error.component';

const FormErrorModule = angular
    .module('control-room.commons.form.component.form-error', [])
    .component('crFormError', Component);

export default FormErrorModule;
